import homeCover from '../../../assets/home-cover.webp';
import { Loading, ProgramsPreview } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../../routes/types';
import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { ReactComponent as UniversityIcon } from '../../../assets/Icons/fit-logo.svg';
import { ReactComponent as MapPinIcon } from '../../../assets/Icons/location-pin-icon.svg';
import React from 'react';
import { useQuery } from '@apollo/client';
import { GetViewerAvailableProgramsDocument } from '@sandtech-hub-monorepo/ehub-client';

export const HomeNotEnrolled = () => {
  const { data } = useQuery(GetViewerAvailableProgramsDocument);

  if (!data) {
    return <Loading />;
  }

  return (
    <div>
      <img
        src={homeCover}
        alt="cover"
        className="w-full max-h-80 object-cover"
      />
      <div className="flex gap-0 md:gap-16 px-6 flex-wrap md:flex-nowrap  max-w-screen-2xl mx-auto">
        <div className="bg-background-secondary p-6 border-background border-4 shadow-background inline-block -translate-y-1/2 -mb-[64px] self-start">
          <UniversityIcon height={108} width={108} />
        </div>
        <div>
          <h1 className="mt-10 text-4xl">Frontier Institute of Technology</h1>
          <div className="flex gap-1 mt-4">
            <MapPinIcon color="red" />
            <div className="text-muted-foreground">Jackson, Wyoming, USA</div>
          </div>
        </div>
      </div>
      <div className="h-full pt-8 px-6 pb-12 sm:pt-16 flex flex-col gap-8 max-w-screen-2xl mx-auto">
        <ProgramsPreview
          title="Available Programs"
          programsPageLink={AppRoutesPaths.Programs}
          learningPageLink={AppRoutesPaths.Learning}
          programPageLink={AppRoutesPaths.Program}
          universityOnly
        />
        <Card className="flex gap-8 p-12 flex-wrap bg-banner border-banner">
          <div className="flex-1">
            <h3 className="font-semibold text-banner-heading">
              Course Delivery
            </h3>
            <div className="text-banner-subheading">Online</div>
          </div>
          <div className="border border-r border-[hsla(218,15%,65%,1)] self-stretch"></div>
          <div className="flex-1">
            <h3 className="font-semibold text-banner-heading">
              Scholarship Availability
            </h3>
            <div className="text-banner-subheading">Yes</div>
          </div>

          <div className="border border-r border-[hsla(218,15%,65%,1)] self-stretch"></div>
          <div className="flex-1">
            <h3 className="font-semibold text-banner-heading">
              Estimated Tuition Cost
            </h3>
            <div className="text-banner-subheading">$225 per semester</div>
          </div>
        </Card>
        <Card className="p-12">
          <h2 className="text-2xl font-semibold mb-8">Overview</h2>
          <p className="mb-4 text-lg text-[hsla(0,0%,26%,1)]">
            Frontier Institute of Technology was founded in 2024 and is a
            private, non-profit institution which prepares students to build,
            lead, question, and think critically in an era shaped by disruptive
            technologies. The institution's programs are centered around team
            projects, AI-native workflows, and entrepreneurship as core elements
            of how students work, learn, and solve urgent, complex human
            problems – not around traditional curricula delivered through
            conventional methods.
          </p>
          <p className="mb-4 text-lg text-[hsla(0,0%,26%,1)]">
            The institution is committed to helping students pursue ambitious
            academic and career goals while cultivating the ethical judgment
            that AI-augmented work demands. As technology grows more powerful,
            the need for social responsibility, principled leadership, and
            independent critical thinking grows with it. These values are
            integrated across every program the institution offers.
          </p>
          <p className="text-lg text-[hsla(0,0%,26%,1)]">
            Frontier Institute of Technology is accredited by the Distance
            Education Accrediting Commission. The Distance Education Accrediting
            Commission is recognized by the U.S. Department of Education as an
            institutional accrediting agency and by the Council for Higher
            Education Accreditation (CHEA).
          </p>
        </Card>
        <Card className="p-12">
          <h2 className="text-2xl font-semibold mb-8">Sponsored Placements</h2>
          <p className="mb-4 text-lg text-[hsla(0,0%,26%,1)]">
            The partnership between ALX and the Frontier Institute of Technology
            offers eligible ALX participants the opportunity to qualify for
            sponsored tuition rates and a reduced length completion time in
            obtaining their Bachelor of Science Degrees.
          </p>
          <p className="mb-4 text-lg text-[hsla(0,0%,26%,1)]">
            Applicants who meet the below criteria can have the opportunity to
            receive a special, sponsored tuition rate of $225 USD per semester,
            a streamlined application process, and credit for prior learning
            that will reduce the time and cost to complete the degree program:
          </p>
          <ul className="list-disc list-inside mb-4 text-lg text-[hsla(0,0%,26%,1)]">
            <li>Successful completion of ALX Pathway Foundations</li>
            <li>
              Meet all other admissions requirements established by the school
            </li>
          </ul>
          <p className="text-lg text-[hsla(0,0%,26%,1)]">
            For all other prospective students, the full-time tuition rates of
            $12,000 a year for the Frontier Institute of Technology Degree
            Programs will be applicable
          </p>
        </Card>
        <Card className="p-12">
          <h2 className="text-2xl font-semibold mb-8">Accreditations</h2>
          <div className="flex space-x-4">
            <div className="px-6 py-2 bg-background-tertiary rounded-2xl text-center font-medium text-xl border border-[hsla(221,39%,11%,1)]">
              DEAC
            </div>
            <div className="px-6 py-2 bg-background-tertiary rounded-2xl text-center font-medium text-xl border border-[hsla(221,39%,11%,1)]">
              CHEA
            </div>
          </div>
        </Card>
        <Card className="p-12">
          <h2 className="text-2xl font-semibold mb-8">Programs Available</h2>
          <div className="flex flex-col items-start space-y-4">
            {data.viewer.availablePrograms?.map(
              ({ name, id, isUniversityProgram }) =>
                isUniversityProgram && (
                  <div
                    key={id}
                    className="px-6 py-2 bg-background-tertiary rounded-2xl text-center font-medium text-xl border border-[hsla(221,39%,11%,1)]"
                  >
                    {name}
                  </div>
                )
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};
